module.exports = require("./ff-Latn-SL.d.ts");